"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var auth_1 = require("Public/store/modules/auth");
var vuex_1 = require("vuex");
var mixin = {
    computed: __assign({}, (0, vuex_1.mapGetters)({ user: auth_1.AUTH_USER_GET })),
};
exports.default = mixin;
